// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------
const getIcon = (name) => (
  <SvgIconStyle src={`${process.env.PUBLIC_URL}/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />
);
const ICONS = {
  blog: getIcon('ic_blog'),
  cache: getIcon('ic_cache'),
  video: getIcon('ic_booking'),
  user: getIcon('ic_user'),
  analytics: getIcon('ic_dashboard'),
  shop: getIcon('ic_cart'),
  quiz: getIcon('ic_banking'),
};
const navConfig = [
  // GENERAL
  {
    subheader: 'menu.general',
    items: [
      {
        title: 'menu.analytics',
        path: PATH_DASHBOARD.dashboard.analytics, icon: ICONS.analytics,
        hasRoles: ["ROLE_ADMIN", 'ROLE_MANAGER', 'ROLE_EDITOR']
      }
    ],
  },
  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'menu.gplx',
    items: [
      {
        title: 'menu.situation',
        path: "",
        icon: ICONS.video,
        hasRoles: ["ROLE_ADMIN"],
        children: [
          { title: 'menu.situation', path: PATH_DASHBOARD.gplx.situations },
          { title: 'menu.exam', path: PATH_DASHBOARD.gplx.exams },
          { title: 'menu.category', path: PATH_DASHBOARD.gplx.categories },
          { title: 'menu.practicalExam', path: PATH_DASHBOARD.gplx.practicalExams },
          { title: 'menu.licenseType', path: PATH_DASHBOARD.gplx.licenseTypes },
        ],
      },
      {
        title: 'menu.quiz',
        path: '',
        icon: ICONS.quiz,
        hasRoles: ["ROLE_ADMIN", "ROLE_QUIZ"],
        children: [
          { title: 'menu.exam', path: PATH_DASHBOARD.quiz.exams },
          { title: 'menu.question-group', path: PATH_DASHBOARD.quiz.qgroups },
          { title: 'menu.question-category', path: PATH_DASHBOARD.quiz.categories },
          { title: 'menu.question', path: PATH_DASHBOARD.quiz.questions },
          { title: 'menu.answer', path: PATH_DASHBOARD.quiz.answers },
        ],
      },
      {
        title: 'menu.shop',
        path: '',
        icon: ICONS.shop,
        hasRoles: ["ROLE_ADMIN", "ROLE_SHOP"],
        children: [
          { title: 'menu.affiliate', path: PATH_DASHBOARD.shop.affiliates },
        ],
      },
      {
        title: 'menu.user',
        path: "",
        icon: ICONS.user,
        hasRoles: ["ROLE_ADMIN"],
        children: [
          { title: 'menu.user', path: PATH_DASHBOARD.gplx.users },
          { title: 'menu.privilege', path: PATH_DASHBOARD.gplx.privileges },
          { title: 'menu.role', path: PATH_DASHBOARD.gplx.roles },
        ],
      },
      {
        title: 'menu.system',
        path: "",
        icon: ICONS.cache,
        hasRoles: ["ROLE_ADMIN"],
        children: [
          { title: 'menu.cache', path: PATH_DASHBOARD.gplx.caches },
          { title: 'menu.setting', path: PATH_DASHBOARD.gplx.settings },
          { title: 'menu.notification', path: PATH_DASHBOARD.gplx.notifications },
        ],
      }
    ],
  },
];
export default navConfig;
